<template>
  <div>
    <v-dialog v-if="uploadSSCCodeDialog" v-model="uploadSSCCodeDialog" width="700">
      <v-card>
        <v-card-title>
          Import SSC Code File
        </v-card-title>
        <v-card-text>
          <v-form-file @uploaded="uploadSSCCode" label="SSC Code File"
                       target="ofd"
                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                       return-url
                       xx-large></v-form-file>
          <v-form-selector :clearable="false" v-model="factoryId" label="Factory"
                           items="邦威|1,帮登|2,鸿森|3,足友|4,越南|5,备用工厂|6"></v-form-selector>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :loading="$store.getters.loading['BOX_IMPORT']" @click="importConfirm"
                 color="primary" tile>OK
          </v-btn>
          <v-btn @click="uploadSSCCodeDialog=false" outlined tile>CANCEL
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-page-data-table
        title="Box Manage"
        key-name="id"
        :fields="fields"
        ref="box"
        @create="onDetail"
        @import="importEPL"
        dense
        :show-edit="false"
        :show-delete="isAdmin"
        :row-actions="rowActions"
        :toolbar-actions="toolActions"
        delete-api="ORDER_DELETE"
        query-api="ORDER_QUERY">

      <template v-slot:po="{item}">
        <v-link-text :text="item.po" @click="onDetail(item)"></v-link-text>
      </template>
      <template v-slot:scaned="{item}">
        {{item.boxScaned}}/{{item.pieceScaned}}
      </template>
      <template v-slot:unscan="{item}">
        {{item.boxQuantity-item.boxScaned}}/{{item.pieceQuantity-item.pieceScaned}}
      </template>
      <template v-slot:boxStatus="{item}">
        <v-btn text tile small>
          {{item.boxStatus}}
        </v-btn>
      </template>
    </v-page-data-table>
  </div>
</template>

<script>
import ContainerQueryFields from "./fields/BoxQueryFields";

export default {
  name: "ContainerQuery",
  data() {
    return {
      uploadSSCCodeDialog: false,
      fields: ContainerQueryFields,
      fileUuid: null,
      factoryId: null,
      isAdmin:false,
      rowActions: [],
      toolActions: [
        {
          text: 'upload',
          color: 'primary',
          accessRole:'SMS_ADMIN',
          icon: "mdi-upload",
          action: 'import'
        }
      ]
    }
  },
  created() {
    this.isAdmin=this.$tool.hasRole("SMS_ADMIN");
  },
  methods: {
    onDetail(item) {
      let id = item ? item.id : undefined;
      this.$router.apmRoute("boxDetail", {id: id});
    },
    viewImage(url) {
      window.open(url, '_blank');
    },
    importEPL() {
      this.uploadSSCCodeDialog = true;
    },
    uploadSSCCode(items) {
      if (items && items.length > 0) {
        this.fileUuid = items[0].uuid;
      }
    },
    importConfirm() {
      if (!this.factoryId) {
        this.$message.error("请选择工厂");
        return;
      }
      this.$request.request("BOX_IMPORT", {
        fileUuid: this.fileUuid,
        factoryId: this.factoryId
      }).then((response) => {
        this.$message.success("Import success");
        this.uploadSSCCodeDialog = false;
        this.$refs.box.query();
      });
    }
  }
}
</script>
